//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';

import { faUsers } from '@fortawesome/pro-regular-svg-icons';
import { faCheck, faXmark } from '@fortawesome/pro-solid-svg-icons';
import Money from '@motionelements/money';
import { publishedContentCounts, renderContentCount } from '@motionelements/core/src/helpers/contentCount.js';

export default {
  name: 'CorporateComparisonTable',
  components: {
    UnlimitedSubscriptionPrice: () => import('@/components/pricing/UnlimitedSubscriptionPrice.vue'),
  },
  data() {
    return {
      faCheck,
      faXmark,
      faUsers,
      list: [
        this.$t('corporate.comparison_table.multiple_users'),
        this.$t('corporate.comparison_table.sub_account_setup'),
        this.$t('corporate.comparison_table.budget_allocation'),
        this.$t('corporate.comparison_table.unified_storage'),
      ],
      teamMembersCount: 0,
      teamMembersCountList: [
        {
          value: 1,
          price: {
            JPY: { amount: 125800, currency: 'JPY' },
            KRW: { amount: 1332800, currency: 'KRW' },
          },
          title: '1-5',
        },
        {
          value: 2,
          price: {
            JPY: { amount: 175800, currency: 'JPY' },
            KRW: { amount: 1932800, currency: 'KRW' },
          },
          title: '6-10',
        },
        {
          value: 3,
          price: {
            JPY: { amount: 275800, currency: 'JPY' },
            KRW: { amount: 3132800, currency: 'KRW' },
          },
          title: '11-20',
        },
        {
          value: 4,
          title: '21+',
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      currencyCode: 'user/currencyCode',
    }),
    totalSubscriptionCount() {
      return renderContentCount(this, publishedContentCounts.total.subscription.element);
    },
    isSupportedPlan() {
      const isJPY = this.$i18n.locale === 'ja' && this.currencyCode === 'JPY';
      const isKRW = this.$i18n.locale === 'ko' && this.currencyCode === 'KRW';
      return isJPY || isKRW;
    },
    chosenTeamMembersCountPrice() {
      const chosenPrice = _.get(this.teamMembersCountList[this.teamMembersCount], 'price');
      return _.get(chosenPrice, this.currencyCode);
    },
  },
  methods: {
    price(price) {
      if (price) {
        return Money(price).toFormat('$0,0');
      }
      return null;
    },
  },
};
